import React, { useCallback, useRef, useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
interface BeforeAfterSliderProps {
  beforeSrc: string;
  afterSrc: string;
  beforeLabel?: string;
  afterLabel?: string;
}
export function BeforeAfterSlider({
  beforeSrc,
  afterSrc,
  beforeLabel = 'Pred',
  afterLabel = 'Po'
}: BeforeAfterSliderProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const draggingRef = useRef(false);
  const [position, setPosition] = useState(50);
  const updateFromClientX = useCallback((clientX: number) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = (clientX - rect.left) / rect.width * 100;
    setPosition(Math.min(100, Math.max(0, pct)));
  }, []);
  const handlePointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    draggingRef.current = true;
    (e.target as Element).setPointerCapture?.(e.pointerId);
    updateFromClientX(e.clientX);
  };
  const handlePointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!draggingRef.current) return;
    updateFromClientX(e.clientX);
  };
  const stopDragging = () => {
    draggingRef.current = false;
  };
  return <div ref={containerRef} className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden select-none cursor-ew-resize shadow-lg border border-gray-100 touch-none" onPointerDown={handlePointerDown} onPointerMove={handlePointerMove} onPointerUp={stopDragging} onPointerLeave={stopDragging} data-id="element-205" data-mp="2fjzch7pnrywh">
      <img src={beforeSrc} alt={beforeLabel} className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} data-id="element-206" data-mp="1ivb6j9r7w23f" />
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} data-id="element-207" data-mp="1rueqefy7kliz">
        <img src={afterSrc} alt={afterLabel} className="absolute inset-0 w-full h-full object-cover" draggable={false} data-id="element-208" data-mp="38ar6pzn5ydh6" />
      </div>

      {/* Divider handle */}
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.15)] pointer-events-none" style={{
      left: `${position}%`
    }} data-id="element-209" data-mp="3fc4deuourjao">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl flex items-center justify-center" data-id="element-210" data-mp="3k94l1a1cou3w">
          <MoveHorizontalIcon className="w-4 h-4 text-apple-gray" data-id="element-211" data-mp="2rnl5whdmnajn" />
        </div>
      </div>

      <span className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full pointer-events-none" data-id="element-212" data-mp="2wkv2cgzfomgz">
        {beforeLabel}
      </span>
      <span className="absolute top-4 right-4 bg-apple-blue/90 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full pointer-events-none" data-id="element-213" data-mp="36by65qjqzfjy">
        {afterLabel}
      </span>
    </div>;
}